import type { PageResponse } from '@mall/shared';
import { apiClient } from '../../app/api';
import type { OrderView } from './types';

export interface ListParams {
  page?: number;
  pageSize?: number;
}

export function listOrders(params: ListParams = {}): Promise<PageResponse<OrderView>> {
  return apiClient.get<PageResponse<OrderView>>('/admin/orders', {
    query: {
      page: params.page ?? 1,
      page_size: params.pageSize ?? 20,
    },
  });
}

export function getOrder(id: number): Promise<OrderView> {
  return apiClient.get<OrderView>(`/admin/orders/${id}`);
}

export function payOrder(id: number): Promise<void> {
  return apiClient.post<void>(`/admin/orders/${id}/pay`);
}

export function shipOrder(id: number): Promise<void> {
  return apiClient.post<void>(`/admin/orders/${id}/ship`);
}

export function completeOrder(id: number): Promise<void> {
  return apiClient.post<void>(`/admin/orders/${id}/complete`);
}

export function cancelOrder(id: number): Promise<void> {
  return apiClient.post<void>(`/admin/orders/${id}/cancel`);
}
